import axios from "axios";
import {
  ResponseItem,
  ResponseList,
  ResponseRemove,
} from "../../models/clientModels/interfaces/Response";
import * as Params from "../../models/clientModels/interfaces/apiParams";
import {
  WOStatisticsItem,
  statisticsItemListParams,
} from "../../models/serverModels/workOrder/WOStatisticsItem";

const rootApi = process.env.REACT_APP_API_KEY;

const statisticsItem1 = axios.create({
  baseURL: rootApi,
});

export const getList = async (
  params: statisticsItemListParams
): Promise<ResponseList<WOStatisticsItem>> =>
  statisticsItem1({
    url: "/statisticsItem",
    method: "get",
    params,
  }).then((res) => res.data);

export const getItem = async (params: Params.GetItem): Promise<ResponseItem<WOStatisticsItem>> =>
  statisticsItem1({
    url: `/statisticsItem/${params.id}`,
    method: "get",
    params,
  }).then((res) => res.data);

export const create = async (
  params: Params.Create<WOStatisticsItem>
): Promise<ResponseItem<WOStatisticsItem>> =>
  statisticsItem1({
    url: `/statisticsItem`,
    method: "post",
    data: params,
  }).then((res) => res.data);
export const remove = async (params: Params.Remove): Promise<ResponseRemove> =>
  statisticsItem1({
    url: `/statisticsItem/${params.id}`,
    method: "delete",
    data: params,
  }).then((res) => res.data);

export const update = async (
  params: Params.Update<WOStatisticsItem>
): Promise<ResponseItem<WOStatisticsItem>> =>
  statisticsItem1({
    url: `/statisticsItem/${params.id}`,
    method: "put",
    data: params,
  }).then((res) => res.data);
